import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { lazy, Suspense } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
import TierPromotionCard from '../TierPromotionCard';
const TierPromotionCardWithFellaTooltip = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "ms_ftue" */ './TierPromotionCardWithFellaTooltip')));
export const LoadableTierPromotionCardWithFellaTooltip = (_param)=>{
    var { isPostsFeedCard  } = _param, props = _object_without_properties(_param, [
        "isPostsFeedCard"
    ]);
    const isMounted = useIsMounted();
    const loading = /*#__PURE__*/ React.createElement(TierPromotionCard, _extends({}, props));
    if (!isMounted) {
        return loading;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableTierPromotionCardWithFellaTooltip"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: loading
    }, /*#__PURE__*/ React.createElement(TierPromotionCardWithFellaTooltip, _extends({}, props, {
        isPostsFeedCard: isPostsFeedCard
    }))));
};
LoadableTierPromotionCardWithFellaTooltip.displayName = 'LoadableTierPromotionCardWithFellaTooltip';
export default LoadableTierPromotionCardWithFellaTooltip;
